import { ODataService } from '@common/odata';
import { Observable } from 'rxjs';

export function fetchItemDetailsHelper<T>(service: ODataService<any>, config: { id: string; dateTime: string }): Observable<T> {
  const { id, dateTime } = config || {};
  const query = dateTime ? `?dateTime=${encodeURIComponent(dateTime)}` : '';

  return service.ItemProperty(id, `GetDetails()${query}`);
}
